import React from 'react';
import { Card, Tag } from 'antd';

export default function OrderSummaryCard(props) {
    const { order } = props;

    return (
        <Card title={order.order_code || 'Chi tiết đơn hàng'}>
            <div><strong>Trạng thái:</strong> <Tag>{order.status || 'unknown'}</Tag></div>
            <div><strong>Người xử lý:</strong> {order.assignee && order.assignee.name ? order.assignee.name : 'Chưa assign'}</div>
            <div><strong>Nguồn:</strong> {order.source ? order.source.channel_type || '' : ''}</div>
        </Card>
    );
}
